import './index.less';
import React from 'react';
import classNames from 'classnames';

interface IProp {
  className: string
}

const AdsContent: React.FC<IProp> = ({ className }) => {
  return (
    <figure className={classNames('reg-layer-content clearfix', className)}>
      <img
        className="reg-layer-content-img"
        src="//s.lietou-static.com/fe-lib-pc/v5/logo/square/logo-128x128.png"
        alt="logo"
      />
      <figcaption>
        用猎聘 更高薪
      </figcaption>
    </figure>
  );
}

export default AdsContent;
